import JsBarcode from 'jsbarcode';
import ExcelJS from 'exceljs';
import { TableSorting } from 'components';
// import axios from 'axios'

export async function ExportExcelItemGroup(props: { data: any, tableActive: TableSorting[] }) {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('REGISTER GROUP');

  const columnActive = props.tableActive.filter((c) => c.isActive !== false);
  
  // MODULE
  worksheet.mergeCells(1,1,1, columnActive.length + 1);
  const inventoryTitle = worksheet.getCell('A1');
  inventoryTitle.value = 'INVENTORY';
  inventoryTitle.alignment = { horizontal: 'center', vertical: 'middle' };
  inventoryTitle.font = { size: 15, bold: true };

  const reorderedCols = [
  ...columnActive.filter(c => c.value === 'code'),
  ...columnActive.filter(c => c.value !== 'code'),
];

  // HEADER
  const columnsLength = header({ worksheet, tableActive: reorderedCols }).columnsLength

  // TITLE
  title({ worksheet, columnLength: columnsLength, startRow: 2 })

  // DATA ROWS 
  for (const [index, rowData] of props.data.entries()) {
    const row = worksheet.addRow([]);
    let colIndex = 1;
    row.getCell(colIndex++).value = index + 1;

    for (const col of reorderedCols.filter((c) => c.isActive !== false)) {
      let value: any = '';

      const colTitle = col.value;

      switch (colTitle) {
        case 'bsi':
          value = `${rowData.buy ? "B" : ""}${rowData.sell ? "S" : ""}${rowData.inventory ? "I" : ""}` 
          break;
        case 'code':
          value = rowData.item_code;
          break;
        case 'build':
          value = rowData.build_item ? '✓' : '';
          break;
        case 'name':
          value = rowData.product_name;
          break;
        case 'category':
          value = rowData.mr_product_category_name;
          break;
        case 'average_cost':
          value = Number(rowData.avg_price) ?? '';
          break;
        case 'last_price':
          value = !rowData.build_item && Number(rowData.last_price) ? Number(rowData.last_price) : '';
          break;
        case 'sell_price':
          value = !rowData.build_item && Number(rowData.sell_price) ? Number(rowData.sell_price) : '';
          break;
        case 'soh':
          value = Number(rowData.soh) ?? '-';
          break;
        case 'unit':
          value = rowData.unit_convention;
          break;
        default:
          value = '';
      }

      row.getCell(colIndex++).value = value;
    }

    const itemCodeIndex =  columnActive.findIndex((col) => col.value === 'code');
    if (itemCodeIndex !== -1) {
      await addBarcode({
        workbook,
        value: rowData.product_barcode,
        worksheet,
        row: row,
      });
    }

    cellStyle({ row });
  }


  // Ekspor file Excel
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'register_group.xlsx';
  a.click();
  window.URL.revokeObjectURL(url);
}


const generateBarcode = (productCode: string): Promise<string> => {
  return new Promise((resolve) => {
    const canvas = document.createElement('canvas');

    JsBarcode(canvas, productCode, {
      format: 'CODE128',
      width: 2,
      height: 40,
      displayValue: true,
      margin: 10,
    });

    const barcodeDataUrl = canvas.toDataURL('image/png');
    resolve(barcodeDataUrl);
  });
};

async function addBarcode(props: {
  workbook: ExcelJS.Workbook,
  value: string,
  worksheet: ExcelJS.Worksheet,
  row: ExcelJS.Row
}) {
  const barcodeDataUrl = await generateBarcode(props.value);

  const barcodeId = props.workbook.addImage({
    base64: barcodeDataUrl.split(',')[1],
    extension: 'png',
  });

  return props.worksheet.addImage(barcodeId, {
    tl: { col: 1.2, row: props.row.number - 0.8 },
    ext: { width: 100, height: 40 },
  });

}

// async function addImage(props: {
//   workbook: ExcelJS.Workbook,
//   picturePath: string | null
//   worksheet: ExcelJS.Worksheet,
//   row: ExcelJS.Row
// }) {
//   const { REACT_APP_BASE_URL_API } = process.env

//   const imageUrl = props.picturePath
//     ? `${REACT_APP_BASE_URL_API}/getimage/?imgpath=${props.picturePath}`
//     : null;

//   if (imageUrl) {
//     function toBase64(arrayBuffer: ArrayBuffer): string {
//       let binary = '';
//       const bytes = new Uint8Array(arrayBuffer);
//       const len = bytes.byteLength;
//       for (let i = 0; i < len; i++) {
//         binary += String.fromCharCode(bytes[i]);
//       }
//       return btoa(binary);
//     }

//     const response = await axios.get(imageUrl, { responseType: "arraybuffer" })
//     const base64Image = toBase64(response.data);
//     const imageId = props.workbook.addImage({
//       base64: base64Image,
//       extension: "jpeg"
//     });

//     return props.worksheet.addImage(imageId, {
//       tl: { col: 4.2, row: props.row.number - 0.8 },
//       ext: { width: 100, height: 40 }
//     })
//   }
// }

function cellStyle(props: {
  row: ExcelJS.Row
}) {
  props.row.height = 45;

  props.row.eachCell((cell) => {
    cell.alignment = { vertical: 'middle' };
  });

  // format number
  [7, 8, 9, 10].forEach((colIndex) => {
    const cell = props.row.getCell(colIndex);
    cell.alignment = { horizontal: 'right', vertical: "middle" }
    cell.numFmt = "#,##0"
  });

  [2, 3].forEach((colIndex) => {
    const cell = props.row.getCell(colIndex);
    cell.alignment = { horizontal: 'center', vertical: "middle" }
  });
}

function header(props: {
  worksheet: ExcelJS.Worksheet
  tableActive: TableSorting[]
}) {
  const columns = [
    { header: 'NO', width: 5 },
    ...props.tableActive
      .map(col => ({
        header: col.title.toUpperCase(),
        width: 15
      })),
  ];

  const row = props.worksheet.getRow(4);
  columns.forEach((col, index) => {
    const cell = row.getCell(index + 1);
    cell.value = col.header;
    cell.font = { size: 13, bold: true, color: { argb: 'FFFFFFFF' } };
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FF000000' },
    };
    cell.alignment = { vertical: 'middle', horizontal: 'center' };
    cell.worksheet.getColumn(index + 1).width = col.width;
  });

  return {
    columnsLength: columns.length,
  };
}


function title(props: {
  worksheet: ExcelJS.Worksheet,
  columnLength: number,
  startRow?: number
}) {
  const row = props.startRow ?? 1;
  props.worksheet.mergeCells(row, 1, row, props.columnLength);
  const titleCell = props.worksheet.getCell(row, 1);
  titleCell.value = 'REGISTER GROUP';
  titleCell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
  titleCell.font = { bold: true, size: 15 };
}

